module.exports = __webpack_public_path__ + "img/01.50ff8325.webp";